import {reducer as loginModal} from '~/common/fabric/Card/components/LoginModal/reducer';
import {api as guestsApi} from '~/common/fabric/EventGuests/api/api';
import {reducer as details} from './details';
import {reducer as guests} from '~/common/fabric/EventGuests/reducers/guests/index';
import {reducer as review} from '~/common/fabric/reducers/review/index';
import {reducer as fabricTemplate} from './fabricTemplate';
import {reducer as fabricDesign} from './fabricDesign';
import {reducer as eviteEvent} from './eviteEvent';
import {reducer as user} from '~/common/fabric/User/reducers/user';
import {reducer as recipientsMessage} from './recipientsMessage';
import {reducer as eGiftCard} from '~/common/fabric/GiftCard/reducers/eGiftCard';
import {reducer as webview} from './webview/reducer';
import {reducer as snapshot} from '~/common/fabric/Snapshot/reducers';
import {reducer as cachedMedia} from '~/common/reducers/cachedMedia';
import {api} from '~/CreateFabricInvitation/api/api';

export const rootReducer = {
  [api.reducerPath]: api.reducer,
  [guestsApi.reducerPath]: guestsApi.reducer,
  details,
  fabricDesign,
  fabricTemplate,
  guests,
  loginModal,
  eviteEvent,
  user,
  review,
  recipientsMessage,
  eGiftCard,
  webview,
  premiumDesign: (state = {}) => state,
  eventDetails: (state = {}) => state,
  snapshot,
  cachedMedia,
};
